/* @flow */
import * as React from 'react'
import $ from 'jquery'
import fastdom from 'fastdom'

const criticalEvents = [
    'onClick',
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate',
    'onContextMenu',
    'onDoubleClick',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onScroll',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onWheel',
]

const stopEvent = (event) => {
    event.stopPropagation()
}

// $FlowFixMe
const criticalEventsHandlers = criticalEvents.reduce((acc, val) => ({ ...acc, [val]: stopEvent }), {})

class FullscreenOverlay extends React.Component<{
    children: React.Element<*>,
    stopCriticalEvents?: boolean,
    transparent?: boolean,
}> {
    // eslint-disable-next-line react/sort-comp
    lastScrollTopValue: number

    static defaultProps = {
        transparent: false,
    }

    componentDidMount() {
        const scrollTop = document.getElementsByTagName('html')[0].scrollTop
        fastdom.measure(() => {
            if (scrollTop) {
                this.lastScrollTopValue = scrollTop
            }

            fastdom.mutate(() => {
                $('body').addClass('is-scrolling-disabled')

                if (document.body) {
                    document.body.style.top = `${-this.lastScrollTopValue}px`
                }
            })
        })
    }

    componentWillUnmount() {
        // Position fixed from .is-scrolling-disabled sets window position
        // to 0. We need to set it back after class is removed.
        fastdom.mutate(() => {
            $('body').removeClass('is-scrolling-disabled')

            if (this.lastScrollTopValue && document.body) {
                document.body.style.top = '0'
                document.getElementsByTagName('html')[0].scrollTop = this.lastScrollTopValue
            }
        })
    }

    render() {
        const { stopCriticalEvents, transparent, ...restProps } = this.props

        const eventHandlers = stopCriticalEvents ? criticalEventsHandlers : {}

        let className = 'fullscreenOverlay'

        if (transparent) {
            className += ' fullscreenOverlay-transparent'
        }

        return (
            // $FlowFixMe
            <div className={className} {...eventHandlers} {...restProps}>
                {this.props.children}
            </div>
        )
    }
}

export default FullscreenOverlay
